import axios from 'axios';
import forEach from 'lodash/forEach';
import merge from 'lodash/merge';

import { createAction } from '../../utils/redux-helper';
import * as ActionDefinitions from './actionDefinitions';

/* TO REMOVE */
export const fetch = (id, options, beforeActions = false, successActions = false, errorActions = false) => dispatch => {
  dispatch(fetchRequest(id));
  beforeActions && beforeActions.forEach(ba => dispatch(ba()));

  return axios(options).then(function (response) {
    // console.log(response);
    dispatch(fetchSuccess(id));
    successActions && successActions.forEach(sa => dispatch(sa(response.data)));
    return Promise.resolve(response.data);

  }).catch(function (error) {
    // console.log(error);
    dispatch(fetchFailure(id, error));
    errorActions && errorActions.forEach(ea => dispatch(ea(error)));
    return Promise.reject(error);
  });
};

export const fetchRequest = (source) => {
  const payload = { source };
  return createAction(ActionDefinitions.FETCH_REQUEST, payload);
};

export const fetchSuccess = (source) => {
  const payload = { source };
  return createAction(ActionDefinitions.FETCH_SUCCESS, payload);
};

export const fetchFailure = (source, error) => {
  const payload = { source, error };
  return createAction(ActionDefinitions.FETCH_FAILURE, payload);
};


export const updatedFetch = (method = 'GET', url = '/', params = {}, beforeActions = [], successActions = [], errorActions = [], options = {}) => dispatch => {
  const log = { location: window.location, method, url, params, beforeActions, successActions, errorActions, options };
  dispatch(fetchRequest(log));
  beforeActions && forEach(beforeActions, br => dispatch(br()));

  const axiosOptions = {
    method,
    headers: { 'Content-Type': 'application/json' },
    url
  };

  if(method !== 'GET') {
    axiosOptions.data = JSON.stringify(params);
  } else {
    axiosOptions.params = params;
  }

  if(options) {
    merge(axiosOptions, options);
  }

  return axios(axiosOptions)
  .then(response => {
    dispatch(fetchSuccess(log));
    successActions && forEach(successActions, sa => dispatch(sa(response.data)));
    return Promise.resolve(response.data);
  }).catch((error) => {
    dispatch(fetchFailure(log, error));
    errorActions && forEach(errorActions, ea => dispatch(ea(error)));
    return Promise.reject(error);
  });
};
